import Pagination from "./Pagination/index";
import EntityCount from "./EntityCount/index";
import IconComposer from "./IconComposer";
import LockBodyScroll from "./LockBodyScroll";
import ScrollToTop from "./ScrollToTop";
import SetCSSProperty from "./SetCSSProperty";
import SkipLink from "./SkipLink";
import LabelWithIcon from "./LabelWithIcon";
import RouteAnnouncer from "./RouteAnnouncer";

export default {
  Pagination,
  EntityCount,
  IconComposer,
  LockBodyScroll,
  ScrollToTop,
  SkipLink,
  LabelWithIcon,
  SetCSSProperty,
  RouteAnnouncer
};
